export const url: any = {
    env: "live",
    baseUrl: "https://portal.upmetrorail.com",
    // baseUrl: "https://upmrc-admin.stagemyapp.com",
    s3Url: "https://upmrcl-media.s3.amazonaws.com",
    // domains: {
    //     main: "upmrc-prod.stagemyapp.com",
    //     lucknow: "lucknow-upmrc-prod.stagemyapp.com",
    //     kanpur: "kanpur-upmrc-prod.stagemyapp.com",
    //     agra: "agra-upmrc-prod.stagemyapp.com"
    // },
    // domains: {
    //     main: "upmrc-uat.stagemyapp.com",
    //     lucknow: "lucknow-upmrc-uat.stagemyapp.com",
    //     kanpur: "kanpur-upmrc-uat.stagemyapp.com",
    //     agra: "agra-upmrc-uat.stagemyapp.com"
    // },
    domains: {
        main: "upmetrorail.com",
        lucknow: "lucknow.upmetrorail.com",
        kanpur: "kanpur.upmetrorail.com",
        agra: "agra.upmetrorail.com"
    },
    // domains: {
    //     main: "upmrc-prod.localhost",
    //     lucknow: "lucknow-upmrc-prod.localhost",
    //     kanpur: "kanpur-upmrc-prod.localhost",
    //     agra: "agra-upmrc-prod.localhost"
    // },
    home: "/api/v2/upmrc_homepage/",
    menu: "/api/v2/menus/",
    city: "/api/v2/cities_list/",
    line: "/api/v2/lines_list_by_city/",
    station: "/api/v2/stations_list_by_city_line/",
    stationDetail: "/api/v2/station_detail/",
    tenders: "/api/v2/tenders_by_category/",
    tendersCategory: "/api/v2/tenders_categories/",
    pages: "/api/v2/pages/",
    tours: "/api/v2/tour_guide/",
    city_page: "/api/v2/city_page/",
    searchStation: "/api/v2/stations_by_keyword/",
    searchStOrLt: "/api/v2/stations_localities_by_keyword/",
    updates: "/api/v2/line_detail/",
    station_brief_detail: "/api/v2/station_brief_detail/",
    travel_distance_time_fare: "/api/v2/travel_distance_time_fare/",
    station_route: "/api/v2/route/",
    facilityList: "/api/v2/facility_list/",
    stationsByFacility: "/api/v2/stations_list_by_facility/",
    stationsByLostFound: "/api/v2/lost_items/",
    ongoingEvents: "/api/v2/ongoing_events/",
    homePageEvents: "/api/v2/home_page_events/",
    registration: "/api/v2/registration/",
    login: "/api/v2/login/",
    logout: "/api/v2/logout/",
    submitFeedback: "/api/v2/feedback_post/",
    footerMenu: "/api/v2/menus/footer-menu/",
    searchApi: "/api/v2/search_page/",
    notifications: "/api/v2/upmrc/notification/",
    eventPost: "/api/v2/event_participate_post/",
    mediaGallery: "/api/v2/media_gallery/",
    mediaVideos: "/api/v2/media_video_list/",
    mediaGalleryDetails: "/api/v2/media_gallery_details/",
    contactUs: "/api/v2/contact_us/",
    pressRelease: "/api/v2/pressrelease/",
    pressReleaseDetails: "/api/v2/pressrelease_details/",
    visitorCounter: "/api/v2/total_visitors_count/",
    visitorCountUpdate: "/api/v2/visitor_count_update/",
    metroMarvel: "/api/v2/metro_marvel/",
    complaintCategories: "/api/v2/complaint_category/",
    complaintPost: "/api/v2/complaint_post/",
    notices: "/api/v2/notices_list/",
    get_sitemap: "/api/v2/sitemap/",
    banners: "/api/v2/banners/",
    lucknowBanners: "/api/v2/lucknow_banners/",
    kanpurBanners: "/api/v2/kanpur_banners/",
    agraBanners: "/api/v2/agra_banners/",
    getTokenDetail: "/api/v2/check_login/",
    send_otp: "/api/v2/send-otp/",
    verify_otp: "/api/v2/verify-otp/",
    reset_password: "/api/v2/reset-password/",
    // cityWeather: `https://api.weatherapi.com/v1/current.json?key=${process.env.REACT_APP_WEATHER_API_KEY}`
};